import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { ConnectionsColumnsState, ConnectionsTableState } from "./types";
import type { Key } from "react";

const initialState: ConnectionsTableState = {
  columns: {
    person: true,
    title: true,
    connectedAs: true,
    additionalInformation: true,
    activity: false,
    industry: false,
    role: false,
    birthday: false,
  },
  deleteModalIsOpen: false,
  settingsModalIsOpen: false,
  createModalIsOpen: false,
  editModalIsOpen: false,
  selectedIds: [],
};

export const connectionsTableSlice = createSlice({
  initialState: initialState,
  name: "connectionTable",
  reducers: {
    setColumnsState: (state, action: PayloadAction<ConnectionsColumnsState>) => {
      state.columns = action.payload;
    },
    setSelectedConnectionsIds: (state, action: PayloadAction<Key[]>) => {
      state.selectedIds = action.payload;
    },
    openSettingsModal: (state) => {
      state.settingsModalIsOpen = true;
    },
    closeSettingsModal: (state) => {
      state.settingsModalIsOpen = false;
    },
    openDeleteModal: (state) => {
      state.deleteModalIsOpen = true;
    },
    closeDeleteModal: (state) => {
      state.deleteModalIsOpen = false;
    },
    openCreateModal: (state) => {
      state.createModalIsOpen = true;
    },
    closeCreateModal: (state) => {
      state.createModalIsOpen = false;
    },
    closeEditModal: (state) => {
      state.editModalIsOpen = false;
    },
    openEditModal: (state) => {
      state.editModalIsOpen = true;
    },
  },
  selectors: {
    getColumnsState: (state) => state.columns,
    getSelectedConnecionsIds: (state) => state.selectedIds,
    getDeleteModalIsOpen: (state) => state.deleteModalIsOpen,
    getCreateModalIsOpen: (state) => state.createModalIsOpen,
    getEditModalIsOpen: (state) => state.editModalIsOpen,
    getSettingsModalIsOpen: (state) => state.settingsModalIsOpen,
  },
});

export const { actions: connectionsTableSliceActions, selectors: connectionsTableSliceSelectors } =
  connectionsTableSlice;
